import { render } from "./BillOfMaterialSetup.vue?vue&type=template&id=795c5512"
import script from "./BillOfMaterialSetup.vue?vue&type=script&lang=js"
export * from "./BillOfMaterialSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__